import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import OLFormatGeoJSON from 'ol/format/GeoJSON'

import * as PoziUtils from 'api/utils'

export default function (titleid, asString = true) {
  console.debug('GetGeoJSON', titleid, asString)

  const olLayer = PoziUtils.getOpenLayersObjectFromTitleID(titleid)
  const source = olLayer.getSource()
  if (isNil(source) || isNil(source.getFeatures)) {
    return null
  }
  const olFeaturesArr = source.getFeatures()
  if (isNil(olFeaturesArr) || olFeaturesArr.length === 0) {
    return null
  }

  const options = {
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:3857'
  }

  const geojson = new OLFormatGeoJSON().writeFeaturesObject(olFeaturesArr, options)

  // Determine if the layer has field aliases defined. If so, we will
  // loop through all features and rename the field if there is
  // a matching alias
  const layerConf = PoziUtils.getLayerFromTitleID(titleid)
  const layerAttributes = layerConf.attributes || {}

  // Extract all fields that have aliases into a new fieldAliases object
  const fieldAliases = Object.values(layerAttributes)
    .filter(layerAttribute => !!layerAttribute.alias)
    .reduce((aliases, layerAttribute) => {
      aliases[layerAttribute.name] = layerAttribute.alias
      return aliases
    }, {})

  // Loop through all features in the geojson and replace their property field names with
  // the aliases. We create completely new properties objects to preserve the field order.
  if (!isEmpty(fieldAliases)) {
    // console.debug('GetGeoJSON field aliases', titleid, fieldAliases)

    const features = geojson.features || []
    for (const feature of features) {
      const properties = feature.properties
      if (!properties || isEmpty(properties)) {
        continue
      }

      const newProperties = Object.keys(properties)
        .reduce((newProps, field) => {
          // Use existing field name or alias, if available
          const newField = fieldAliases[field] || field
          newProps[newField] = properties[field]

          return newProps
        }, {})

      // Replace existing properties with the new ones
      feature.properties = newProperties

      // console.debug('GetGeoJSON newProps', titleid, newProperties, feature)
    }
  }

  // Convert to string (default)
  if (asString) {
    // Convert GeoJSON object into string
    const geojsonString = JSON.stringify(geojson, null, '  ')

    return geojsonString
  }

  return geojson
}
